import { Button } from "@mui/material";

import { getSettlementActionButtonSx } from "../../style/styles";

function SettlementButton({ children, disabled, onClick, variant = "contained" }) {
  const isOutlined = variant === "outlined";

  return (
    <Button
      className="w-1/2"
      disabled={disabled}
      onClick={onClick}
      sx={getSettlementActionButtonSx({ disabled, isOutlined })}
      variant={isOutlined ? "outlined" : "contained"}
    >
      {children}
    </Button>
  );
}

export default function SettlementActionButtons({
  disableSave,
  handleOnClickSaveButton,
  disableCancel,
  handleOnClickCancelBtn,
  cancelLabel = "Cancel",
  saveLabel = "Save",
}) {
  return (
    <div className="flex w-1/2 flex-row justify-start gap-2 px-2 py-4">
      <SettlementButton
        disabled={disableCancel}
        onClick={handleOnClickCancelBtn}
        variant="outlined"
      >
        {cancelLabel}
      </SettlementButton>
      <SettlementButton disabled={disableSave} onClick={handleOnClickSaveButton}>
        {saveLabel}
      </SettlementButton>
    </div>
  );
}
